import {Link} from "react-router-dom";
import React, {Component} from 'react';

class MyLink extends Component {
    render() {
        return (
            <p style={{padding:0, margin:0}}>
                <Link to={this.props.to} className={'read-more'}>
                    {this.props.text}
                </Link>
            </p>
        )
    }
}
export default MyLink;


